'use client'

import {useContext} from 'react'
import {createWithEqualityFn, useStoreWithEqualityFn} from 'zustand/traditional'
import {HeaderContext} from '../contexts'
import {shallow} from 'zustand/shallow'

interface useHeaderStoreProps {
	blocks,
	addBlock: (value) => void,
	removeBlock: (value) => void,
}

export const createHeaderStore = (value) => {
	return createWithEqualityFn<useHeaderStoreProps>(set => ({
		blocks: [],
		addBlock: ref => {
			set(state => ({
				blocks: state.blocks.concat(ref),
			}))
		},
		removeBlock: ref => set(state => {
			const indexToRemove = state.blocks.indexOf(ref)

			if (indexToRemove !== -1) {
				const blocks = state.blocks.filter((block, index) => index !== indexToRemove)
				return {blocks}
			}

			return {blocks: state.blocks}
		}),
		...value,
	}), shallow)
}

export const useHeaderStore = (
	selector: (state: useHeaderStoreProps) => Partial<useHeaderStoreProps>,
) => {
	const store = useContext(HeaderContext)
	if (!store) throw new Error('Missing HeaderContext.Provider in the tree')
	return useStoreWithEqualityFn(store, selector)
}
